import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blackout-battle-rtx',
  templateUrl: './blackout-battle-rtx.component.html',
  styleUrls: ['./blackout-battle-rtx.component.css']
})
export class BlackoutBattleRtxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
